export default __webpack_public_path__ + "static/media/protected.a92ea6f0.png";